/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import Swiper from 'swiper';
import BaseFeature from '../../foundation/base/base';
import { detectBrowser, Browsers } from '../../foundation/utilities/detectBrowsers';

const DefaultBreakpoints = {
	900: {
		slidesPerView: 2,
		spaceBetween: 20,
	},
	480: {
		slidesPerView: 1,
		spaceBetween: 20,
	}
};

class ModuleSwipe extends BaseFeature {
	constructor(element) {
		super(element);

		this.el = element;

		this.numberOfPages = this.el.querySelectorAll('.swiper-slide').length || 0;
		this.paginationDots = this.el.querySelector('.swiper-pagination') || null;
		this.paginationHeight = 30;
		this.next = this.el.querySelector('.o-module-swipe__arrow--next');
		this.prev = this.el.querySelector('.o-module-swipe__arrow--prev');
		this.moduleItemCards = document.querySelectorAll('.m-module-item__card');
		this.modulePreviewItemCards = document.querySelectorAll('.m-module-preview-item__card');

		// this.swiperItem = this.el.querySelectorAll('.m-module-item');

		if (this.numberOfPages === 1) {
			if (this.next) {
				this.next.classList.add('swiper-button-disabled');
				this.next.setAttribute('tabindex', '-1');
			}

			if (this.prev) {
				this.prev.setAttribute('tabindex', '-1');
				this.prev.classList.add('swiper-button-disabled');
			}
		}

		this.config = this.el.getAttribute('data-config') ? JSON.parse(this.el.getAttribute('data-config')) : false;

		// Get current ID of swiper
		this.currentSwiperID = this.el.getAttribute('data-instance');
		// Set swiperId to pagination.
		this.el.querySelector('.swiper-pagination').classList.add(`swiper-pagination-${this.currentSwiperID}`);
		this.swiperContainer = this.el.querySelector('[data-ref="module-swipe__swiper-container"]');

		// Swiper configuration
		this.swiperConfig = {
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			a11y: {
				prevSlideMessage: 'Previous slide',
				nextSlideMessage: 'Next slide',
			},
			spaceBetween: this.config.spaceBetween ? parseInt(this.config.spaceBetween, 10) : 20,
			grabCursor: true,
			slidesPerView: this.config.slidesPerView ? parseInt(this.config.slidesPerView, 10) : 2,
			navigation: {
				nextEl: '.o-module-swipe__arrow--next',
				prevEl: '.o-module-swipe__arrow--prev',
			},
			pagination: this.config.pagination ? this.config.pagination : {
				el: `.swiper-pagination-${this.currentSwiperID}`,
				clickable: true,
			},
			// slideClass: 'm-module-item',
			breakpoints: this.config.breakpoints ? this.transformBreakpoints() : DefaultBreakpoints
			// slidesOffsetAfter:-150
		};
		this.initEvents();

		this.bullets = document.querySelectorAll('.swiper-pagination-bullet');
		if (document.getElementById('sliderNext')) {
			document.getElementById('sliderNext').tabIndex = -1;
		}

		if (document.getElementById('sliderPrev')) {
			document.getElementById('sliderPrev').tabIndex = -1;
		}
	}

	initEvents() {
		if ((this.swiper === undefined || this.swiper.destroyed === true) && this.numberOfPages > 1) {
			this.activateSwipe();
		} else {
			this.removeSwipe();
		}

		window.addEventListener('keyup', (e) => {
			const slide = e.target.parentNode;

			if (e.code === 'Tab') {
				e.preventDefault();
				if (this.hasClass('swiper-slide', slide) && !this.hasClass('swiper-slide-active', slide)) {
					this.swiper.slideNext();
				}
			}

			if (e.shiftKey && e.code === 'Tab') {
				if (this.hasClass('swiper-slide', slide) && !this.hasClass('swiper-slide-active', slide) && !this.hasClass('swiper-slide-next', slide)) {
					this.swiper.slidePrev();
				}

				if (this.hasClass('swiper-slide-prev', slide)) {
					this.swiper.slidePrev();
				}
			}

			if (e.code === 'Tab' && this.hasClass('swiper-slide-next', slide)) {
				Array.prototype.slice.call(this.bullets).forEach(bullet => bullet.tabIndex = -1);
			}
		});

		if (this.moduleItemCards) {
			for (let i = 0; i < this.moduleItemCards.length; i++) {
				const card = this.moduleItemCards[i];
				card.classList.add('m-module-item__card--hide-outline');

				card.addEventListener('click', () => {
					card.classList.add('m-module-item__card--hide-outline');
				});

				card.addEventListener('keyup', (e) => {
					if (e.code === 'Tab') {
						card.classList.remove('m-module-item__card--hide-outline');
					}
				});
			}
		}

		if (this.modulePreviewItemCards) {
			for (let i = 0; i < this.modulePreviewItemCards.length; i++) {
				const card = this.modulePreviewItemCards[i];
				card.classList.add('m-module-preview-item__card--hide-outline');

				card.addEventListener('click', () => {
					card.classList.add('m-module-preview-item__card--hide-outline');
				});

				card.addEventListener('keyup', (e) => {
					if (e.code === 'Tab') {
						card.classList.remove('m-module-preview-item__card--hide-outline');
					}
				});
			}
		}
	}

	hasClass(className, target) {
		return new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);
	}

	activateSwipe() {
		this.swiper = new Swiper(this.dom.swiperContainer, this.swiperConfig);
	}

	removeSwipe() {
		if (this.swiper !== undefined) this.swiper.destroy(true, true);
	}

	transformBreakpoints() {
		// Check for IE browser
		if (detectBrowser(Browsers.IE)) {
			return DefaultBreakpoints;
		}

		const { breakpoints } = this.config;

		const transformedBreakpoints = {};

		// Get and transform entry from config.breakpoints
		Object.entries(breakpoints).map(([key, val]) => {
			transformedBreakpoints[key] = {
				slidesPerView: parseInt(val.slidesPerView, 10)
			};
		});
		return transformedBreakpoints;
	}
}

export default ModuleSwipe;
